import { Injectable } from '@angular/core';
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, first, map, switchMap } from 'rxjs/operators';
import { AutorizacaoService } from 'src/app/services/autorizacao-service';
import { environment } from 'src/environments/environment';
import { throwError } from 'rxjs';
import { CandidatoService } from 'src/app/services/candidato.service';
import { toast } from 'src/app/utils/toast';

@Injectable()
export class AutorizacaoInterceptor implements HttpInterceptor {
    constructor(
      private auth: AutorizacaoService,
      private candidatoService: CandidatoService
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        if (req.headers.get('x-skip-autorizacao')) {
            return next.handle(req.clone({
                headers: req.headers.delete('x-skip-autorizacao')
            }));
        }
        return this.auth.autorizacao$.pipe(
            first(),
            map((autorizacao) => {
                if (autorizacao === null) {
                    return null;
                }
                return autorizacao.access_token;
            }),
            switchMap((token) => {
                if (!token) {
                    console.error('[AutorizacaoInterceptor] - usuário não está logado');
                    return next.handle(req);
                }
                const authReq = req.clone({
                    setHeaders: {
                        Authorization: `Bearer ${ token }`,
                    }
                });

                if (!environment.production) {
                console.log(`Bearer ${ token }`);
                }
                return next.handle(authReq).pipe(
                  catchError((err) => {
                      if (token) {
                          if (err.status === 401) {
                              this.auth.usar(null);
                              this.candidatoService.usar(null);
                              toast('Sessão expirada, por favor, realize login novamente.');
                              this.auth.logout$.next(true);
                          }
                      }
                      return throwError(err);
                  })
                );
            })
        );
    }

}
